import { render } from "./BotonVerMas.vue?vue&type=template&id=0d4ae554&scoped=true"
import script from "./BotonVerMas.vue?vue&type=script&lang=js"
export * from "./BotonVerMas.vue?vue&type=script&lang=js"

import "./BotonVerMas.vue?vue&type=style&index=0&id=0d4ae554&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d4ae554"

export default script